<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "BillableRateManagement",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
